import moment from 'moment';
moment.locale('fr');

export function formatDate(date) {
  return moment(date).format('L');
}

export function getImg(img) {
  if (img) return img;
  return require('@/assets/images/default_img.png');
}
export function formatNombre(nombre) {
  const val = nombre ? nombre : 0;
  return new Intl.NumberFormat('fr', { style: 'currency', currency: 'EUR' }).format(val);
}

export function arrondiResult(value) {
  let newValue = value;
  if (newValue) {
    newValue = Math.round(newValue * 100) / 100;
  }
  return newValue;
}
export function getImgPdv(img) {
  if (img) return img;
  return require('@/assets/images/default_img.png');
}

export async function dowloadFileAsync(callback) {
  const result = await callback();
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(result.data);
  const disposition = result.request.getResponseHeader('Content-Disposition');
  link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
  link.click();
}